<template>
  <div>
    <md-dialog
      :md-active.sync="show"
      class="mkt-ops -main-font bookprice-dialog-change-price"
      :md-click-outside-to-close="false"
    >
      <md-dialog-title style="padding-left: 35px;"
        >CHANGE IN PRICINGS</md-dialog-title
      >

      <div class="dialog-content">
        <!-- BLOCK ROW-1 -->
        <div class="md-layout">
          <div
            class="md-layout-item md-size-15 pr25"
            style="padding-left: 5px;"
          >
            <div>
              <div class="-label">Group Code</div>
              <div class="pb10">
                {{ groupCoode }}
              </div>
            </div>
          </div>
          <div class="md-layout-item md-size-85 pr25">
            <div>
              <div class="-label">Description</div>
              <div
                class="pb10"
                style="font-family: Kanit; font-size: 14px; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;"
              >
                {{ desc }}
              </div>
            </div>
          </div>
        </div>

        <!-- TABLE -->
        <div class="md-layout-item md-size-100 table-change-price">
          <!-- HEAD -->
          <div class="divHeadList">
            <div style="width: 6%;">
              <label class="-mkt-checkbox-container">
                <input
                  type="checkbox"
                  v-model="checkedItemAll"
                  @click="selectedCheckedAllItem()"
                />
                <span class="-mkt-checkbox"></span>
              </label>
            </div>
            <div style="width: 9%;">Code</div>
            <div style="width: 38%;">Name</div>
            <div style="width: 10%;" class="-text-right">A3</div>
            <div style="width: 13%; padding-left: 50px;" class="-text-center">
              Change to
            </div>
            <div style="width: 10%;" class="-text-right">A3</div>
            <div style="width: 14%;" class="-text-center">Effective date</div>
          </div>

          <!-- BODY -->
          <div class="divBodyList">
            <div
              v-show="tableChangePrice.length === 0"
              :class="'row-bg-gray'"
              style="display: block; text-align: center; font-size: 14px;"
            >
              No data in table.
            </div>
            <div
              :class="'row-bg-gray'"
              v-for="(item, rIndex) in tableChangePrice"
              :key="rIndex"
            >
              <div style="width: 6%;">
                <label class="-mkt-checkbox-container">
                  <input
                    type="checkbox"
                    v-model="checkedItem"
                    :value="item.code"
                    @click="selectedCheckedCustomer(item.code)"
                  />
                  <span class="-mkt-checkbox"></span>
                </label>
              </div>
              <div style="width: 9%;">{{ item.code }}</div>
              <div
                style="width: 38%;"
                :title="item.title_th"
                class="nowrap-title -font-kanit"
              >
                {{ item.title_th }}
              </div>
              <div style="width: 10%;" class="-text-right">
                {{ item.A3_1 }}
              </div>
              <div style="width: 13%; padding-left: 50px;" class="-text-center">
                <md-icon>arrow_right_alt</md-icon>
              </div>
              <div style="width: 10%;" class="-text-right">
                {{ item.A3_2 }}
              </div>
              <div style="width: 14%;" class="-text-center">
                {{ item.effective_date }}
              </div>
            </div>
          </div>

          <!-- FOOTER -->
          <!-- <div class="footer-table">
            number of lines in page ({{ tableChangePrice.length }})
          </div> -->
        </div>
      </div>

      <md-dialog-actions>
        <div class="md-layout" style="width: 100%;">
          <div class="md-layout-item md-size-35">
            <md-button class="-cancel" @click="onClickCancel()"
              >CANCEL</md-button
            >
          </div>

          <div
            class="md-layout-item md-size-30"
            style="text-align: center; padding-top: 6px; font-style: italic;"
          >
            number of lines in page ({{ tableChangePrice.length }})
          </div>

          <div class="md-layout-item md-size-35" style="text-align: right;">
            <md-button class="-cancel" @click="onClickNotChange()"
              >NOT CHANGE</md-button
            >
            <md-button class="-confirm" @click="onClickConfirm()"
              >CONFIRM CHANGE</md-button
            >
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <dialog-confirm
      :show="showDialogConfirm"
      :content="contentDialog"
      :confirmText="confirmText"
      :cancelText="cancelText"
      @cancel="onCancel()"
      @confirm="onConfirm()"
    ></dialog-confirm>
  </div>
</template>

<script>
import BookpriceService from "@/services/bookprice";
import DialogConfirm from "./../../shared/dialog-confirm";

export default {
  name: "dialog-change-price",

  components: {
    DialogConfirm
  },

  props: {
    show: {
      type: Boolean,
      required: true
    }
  },

  data() {
    return {
      groupCoode: "B01",
      desc: "บริษัท บีทูเอส จำกัด (สาขากาดสวนแก้ว)",
      tableChangePrice: [],
      checkedItemAll: false,
      checkedItem: [],
      showDialogConfirm: false,
      contentDialog: "",
      confirmText: "OK",
      cancelText: "CANCEL",
      checkEvent: ""
    };
  },

  watch: {
    show() {
      if (this.show) {
        BookpriceService.makeDataTableChangePrice().then(response => {
          this.tableChangePrice = response;
        });
      }
    }
  },

  methods: {
    onClickCancel() {
      this.checkEvent = "cancel";
      this.contentDialog = "Are you sure you want to cancel ?";
      this.showDialogConfirm = true;
    },
    onClickNotChange() {
      this.checkEvent = "notchange";
      this.contentDialog = "Are you sure you want to not changes ?";
      this.showDialogConfirm = true;
    },
    onClickConfirm() {
      this.checkEvent = "confirm";
      this.contentDialog = "Are you sure you want to confirm changes ?";
      this.showDialogConfirm = true;
    },
    onCancel() {
      this.showDialogConfirm = false;
    },
    onConfirm() {
      if (this.checkEvent === "cancel") {
        this.$emit("cancel");
      } else if (this.checkEvent === "notchange") {
        this.$emit("notchange");
      } else if (this.checkEvent === "confirm") {
        this.$emit("confirm");
      }
      this.clearData();
      this.showDialogConfirm = false;
    },
    selectedCheckedAllItem() {
      this.checkedItem = [];
      if (!this.checkedItemAll) {
        for (let itemCode in this.tableChangePrice) {
          this.checkedItem.push(this.tableChangePrice[itemCode].code);
        }
      }
    },
    selectedCheckedCustomer(code) {
      if (this.checkedItem.indexOf(code) == -1) {
        this.checkedItem.push(code);
      } else {
        this.checkedItem.splice(this.checkedItem.indexOf(code), 1);
      }

      if (this.checkedItem.length !== this.tableChangePrice.length) {
        this.checkedItemAll = false;
      } else {
        this.checkedItemAll = true;
      }
    },
    clearData() {
      this.checkedItemAll = false;
      this.checkedItem = [];
    }
  }
};
</script>

<style lang="scss" scoped>
.bookprice-dialog-change-price {
  .table-change-price {
    padding: 0;

    .divBodyList {
      height: calc(85vmin - 240px);

      > div .md-icon {
        cursor: text;
      }
    }
  }
}
</style>